import { gql } from '@apollo/client';
import ContentCard from './ContentCard/ContentCard.pim';
import { AssetFragment } from '../graphql/fragments/Asset';

export const SITE_CONFIG = gql`
  query getSettings($key: String, $preview: Boolean) {
    settings(key: $key, preview: $preview) {
      name
      key
      values @client
      resources {
        __typename
        ... on Resource {
          key
          value
        }
        ... on ModalResource {
          key
          title
          cta
          display
          sections {
            label
            content
          }
          defaultSection {
            label
          }
        }
        ... on RichTextResource {
          key
          json: value
        }
        ... on BooleanResource {
          key
          bool: value
        }
        ... on ProductAttributeResource {
          label
          key
          category
          productAttributeCallouts {
            label
            firstMatchOnly
            image {
              ...AssetFragment
            }
            attributes {
              label
              url
              referenceAttributes {
                key
                values
                excluded
              }
              sublabel
              image {
                ...AssetFragment
              }
            }
          }
        }
        ... on TieredOfferResource {
          title
          inProgressBeforeFirstTier {
            ... on Resource {
              key
              value
            }
            ... on RichTextResource {
              key
              json: value
            }
          }
          inProgressAfterFirstTier {
            ... on Resource {
              key
              value
            }
            ... on RichTextResource {
              key
              json: value
            }
          }
          almostThere {
            ... on Resource {
              key
              value
            }
            ... on RichTextResource {
              key
              json: value
            }
          }
          finalTierMet {
            ... on Resource {
              key
              value
            }
            ... on RichTextResource {
              key
              json: value
            }
          }
        }
      }
    }
  }
  ${ContentCard.fragment}
  ${AssetFragment}
`;

export const CURRENT_USER = gql`
  query getCurrentUser {
    user @client
    customerAccessToken @client
    cartId @client
  }
`;

export const GET_USER_LOCALE = gql`
  query getUserLocale {
    user @client {
      locale {
        country
        isConfirmed
      }
    }
  }
`;

export const DISCOUNT_ALLOCATIONS = gql`
  query getDiscounts($cartId: ID!) {
    cart(id: $cartId) {
      ... on Cart {
        id
        __typename
        discountAllocations {
          __typename
          ... on CartCodeDiscountAllocation {
            code
            discountedAmount {
              amount
            }
            __typename
          }
          ... on CartAutomaticDiscountAllocation {
            title
            __typename
          }
          ... on CartCustomDiscountAllocation {
            title
            __typename
          }
        }
        discountCodes {
          __typename
          applicable
          code
        }
      }
    }
  }
`;

export const GET_USER_ID = gql`
  query getUserId($email: String!) {
    user(email: $email) {
      email
      bombasId
    }
  }
`;

export const GET_USER_WITH_WALLET = gql`
  query getUserWithWallet($email: String!, $customerAccessToken: String!) {
    user(email: $email) {
      email
      bombasId
      wallet(customerAccessToken: $customerAccessToken) {
        code
        balance
        currency
        activeCredits {
          amount
          createdDate
          expirationDate
          note
        }
      }
    }
  }
`;

export const COUNTRY_QUERY = gql`
  query getSupportedCountries {
    localization {
      availableCountries {
        name
        isoCode
        unitSystem
        currency {
          isoCode
          name
          symbol
        }
      }
    }
  }
`;

export const GET_CURRENCY = gql`
  query getCurrency($country: CountryCode!) @inContext(country: $country) {
    localization {
      country {
        currency {
          isoCode
        }
        isoCode
      }
    }
  }
`;
export default {};
